import { Recurso } from "lib.common/dist/CleanArch";
import { GestionarProductoDetalleRepository } from "../../business/repositories/GestionarProductoDetalleRepository";
import { DeleteProductoDetalleParams, UpdateProductoDetalleParams } from "../../utils/params/ProductoDetalleParams";
import { GestionarProductoDetalleDtSourceImplGql } from "../dataSources/GestionarProductoDetalleDtSourceImplGql";
import { ProductoDetalleDsKeyModel } from "../models/ProductoDetalleDsKeyModel";
import { ErrExterno } from "lib.common/dist/errorHandler";

export class GestionarProductoDetalleRepositoryImpl implements GestionarProductoDetalleRepository<ProductoDetalleDsKeyModel> {
    private readonly dataSourceGql: GestionarProductoDetalleDtSourceImplGql;
    constructor(dataSource: GestionarProductoDetalleDtSourceImplGql) {
        this.dataSourceGql = dataSource;
    }

    async getAllProductoDetalle(): Promise<Recurso<ProductoDetalleDsKeyModel[]>> {
        try {
            const response = await this.dataSourceGql.getAllProductoDetalle();
            if (response.isSuccess()) {
                return Recurso.fromData<ProductoDetalleDsKeyModel[]>(response.data!.map(ProductoDetalleDsKeyModel.deserialize));
            }
            return Recurso.fromError<ProductoDetalleDsKeyModel[]>(response.error!);
        } catch (error) {
            return Recurso.fromError<ProductoDetalleDsKeyModel[]>(new ErrExterno(error as Error));
        }
    }

    async addProductoDetalle(input: UpdateProductoDetalleParams): Promise<Recurso<ProductoDetalleDsKeyModel>> {
        try {
            const response = await this.dataSourceGql.addProductoDetalle(input);
            if (response.isSuccess()) {
                return Recurso.fromData<ProductoDetalleDsKeyModel>(ProductoDetalleDsKeyModel.deserialize(response.data!));
            }
            return Recurso.fromError<ProductoDetalleDsKeyModel>(response.error!);
        } catch (error) {
            return Recurso.fromError<ProductoDetalleDsKeyModel>(new ErrExterno(error as Error));
        }
    }

    async updateProductoDetalle(input: UpdateProductoDetalleParams): Promise<Recurso<ProductoDetalleDsKeyModel>> {
        try {
            const response = await this.dataSourceGql.updateProductoDetalle(input);
            if (response.isSuccess()) {
                return Recurso.fromData<ProductoDetalleDsKeyModel>(ProductoDetalleDsKeyModel.deserialize(response.data!));
            }
            return Recurso.fromError<ProductoDetalleDsKeyModel>(response.error!);
        } catch (error) {
            return Recurso.fromError<ProductoDetalleDsKeyModel>(new ErrExterno(error as Error));
        }
    }

    async deleteProductoDetalle(input: DeleteProductoDetalleParams): Promise<Recurso<ProductoDetalleDsKeyModel>> {
        try {
            const response = await this.dataSourceGql.deleteProductoDetalle(input);
            if (response.isSuccess()) {
                return Recurso.fromData<ProductoDetalleDsKeyModel>(ProductoDetalleDsKeyModel.deserialize(response.data!));
            }
            return Recurso.fromError<ProductoDetalleDsKeyModel>(response.error!);
        } catch (error) {
            return Recurso.fromError<ProductoDetalleDsKeyModel>(new ErrExterno(error as Error));
        }
    }
}